export const LabelOptionTypes = {
  RADIO: "Radio",
  DROPDOWN: "Dropdown",
  INPUT: "Input"
};
